import { Accordion } from '../../../../../components/general/accordion';
import ChatIcon from '@mui/icons-material/Chat';
import { TitleV1 } from '../../../../../components/titleV1';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Grid, Typography } from '@mui/material';
import { PqrForm } from '../../../pqr/form';
import { useNavigate } from 'react-router-dom';
import { PQR } from '../../../../../../routes/paths';
import { useCasePqr } from './hook';
import { AccountRegisterCaseProps } from './props';
import { Dialog } from '../../../../../components/general/dialog/dialog';
import { Table, TableTooltip } from '../../../../../components/general/table';
import { ISelect } from '../../../../../../shared/types/shared';
import { DateTooltip } from '../../../../../components/general/dateTooltip';

export const AccountRegisterCasePqr = ({
    account,
}: AccountRegisterCaseProps) => {
    const navigate = useNavigate();
    const {
        handleAccordionChange,
        accountHasRecentPqr,
        setAccountHasRecentPqr,
        rows,
        loading,
        page,
        pageSize,
        paginator,
        total,
    } = useCasePqr(account);

    return (
        <Accordion
            title="REGISTRO CASO PQR"
            icon={<ChatIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
            padding={0}
            onChange={handleAccordionChange}
        >
            <TitleV1 title="CASO PQR">
                <LoadingButtonGeneral
                    title="Buscar"
                    variant="outlined"
                    startIcon={<SearchIcon />}
                    onClick={() => navigate(PQR)}
                />
            </TitleV1>
            <Grid px="16px">
                <PqrForm isBpInteraction />
            </Grid>
            {accountHasRecentPqr && (
                <Dialog
                    title="Detalle de PQR recientes"
                    open={accountHasRecentPqr}
                    onClose={() => setAccountHasRecentPqr(false)}
                >
                    <Typography variant="h6" mb={2}>
                        Esta cuenta registra PQR creadas en los últimos 30 días.
                    </Typography>
                    <Typography variant="subtitle1">
                        A continuación se listan las PQR registradas:
                    </Typography>
                    <Box position="relative">
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Table
                                    columns={[
                                        {
                                            field: 'consecutiveFormat',
                                            headerName: 'PQR ID',
                                            flex: 0.4,
                                        },
                                        {
                                            field: 'status',
                                            headerName: 'Estado',
                                            minWidth: 120,
                                            flex: 0.4,
                                            renderCell: (row) => (
                                                <TableTooltip
                                                    value={
                                                        (
                                                            row.row.info
                                                                ?.status as ISelect
                                                        ).name || ''
                                                    }
                                                />
                                            ),
                                        },
                                        {
                                            field: 'created_at',
                                            headerName: 'Fecha de creación',
                                            minWidth: 120,
                                            flex: 0.4,
                                            renderCell: (row) => (
                                                <DateTooltip
                                                    date={row.row.created_at}
                                                />
                                            ),
                                        },
                                    ]}
                                    rows={rows || []}
                                    rowCount={total || 0}
                                    loading={loading}
                                    paginationModel={{
                                        page,
                                        pageSize,
                                    }}
                                    onPaginationModelChange={paginator}
                                    pageSizeOptions={[2, 10, 20, 50]}
                                    disableRowSelectionOnClick
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Dialog>
            )}
        </Accordion>
    );
};
